import directive from './directive';

export default {
  install(Vue, closeComponent) {
    Vue.directive('popover', directive(Vue, closeComponent));
  },
};
